import actionTypes from '../actions/actionTypes'

const defaultState = {
	canvas: '',
	ltiForwardUrl: '',
	ltiToken: '',
	teams: false,
	ltiUid: '',
	extension: '',
	clever: '',
}

function updateLtiParams(state, action) {
	return {
		...state,
		...action.lti,
	}
}

function updateForwardUrl(state, action) {
	return {
		...state,
		ltiForwardUrl: action.payload.forwardUrl,
	}
}

const ltiReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.MY_LIBRARY_INITIALIZE:
			return updateLtiParams(state, action)
		case actionTypes.MY_LIBRARY_SESSION_LTI_CANVAS_SAVED:
			if (!action.teams && action.payload.forwardUrl && !action.payload.postParams &&
					!action.payload.canBeFixed && action.payload.notSupported) {
				return updateForwardUrl(state, action)
			} else {
				return state
			}
		default:
			return state
	}
}

export default ltiReducer
